// extracted by mini-css-extract-plugin
module.exports = {"landing-screen-two":"LandingScreenTwo_landing-screen-two__3fG7u","screen-two-area":"LandingScreenTwo_screen-two-area__32Ja0","mybtn":"LandingScreenTwo_mybtn__1Hyin"};